export default __webpack_public_path__ + "static/media/charts-donnut.0cb65cef.svg";